import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const getOutreachByCareGap = async (careGapId, page = 1, pageSize = 50) => {
  try {
    const response = await axios.get(`${API_URL}/${careGapId}/outreach`, {
      params: { page, pageSize },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching outreach by care gap:", error);
    throw error;
  }
};

export default getOutreachByCareGap;
